define(["exports", "react", "styled-components", "../../themes", "../../atoms/Typography"], function (_exports, _react, _styledComponents, _themes, _Typography) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EmptyMessage = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  // import { size } from '../../../lib';
  // import { styled , keyframes, css } from 'styled-components';
  var Fade = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);

  var MessageStyled = _styledComponents.default.div.withConfig({
    displayName: "EmptyMessage__MessageStyled",
    componentId: "sc-1yz6y7x-0"
  })(["animation:", " 0.8s ", " 0.4s both;align-self:center;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100%;", " > div{", " align-items:center;background:", ";border-radius:50%;display:flex;fill:", ";justify-content:center;box-icon{", ";fill:", ";}}", "{margin-bottom:8px;margin-top:24px;}", "{margin:0 0 24px;padding:0 24px;}"], Fade, function (_ref) {
    var theme = _ref.theme;
    return theme.easing.ease;
  }, function (_ref2) {
    var positionTop = _ref2.positionTop;
    return positionTop && (0, _styledComponents.css)(["padding:72px 0 0;justify-content:end;"]);
  }, (0, _themes.size)(80), function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.lightGray;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.white;
  }, (0, _themes.size)(53), function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.darkGray;
  }, _Typography.H1, _Typography.P);

  var EmptyMessage = function EmptyMessage(_ref6) {
    var title = _ref6.title,
        text = _ref6.text,
        icon = _ref6.icon,
        svg = _ref6.svg,
        top = _ref6.top;
    return /*#__PURE__*/_react.default.createElement(MessageStyled, {
      positionTop: top
    }, icon && /*#__PURE__*/_react.default.createElement("div", null, icon), /*#__PURE__*/_react.default.createElement(_Typography.H1, null, title), /*#__PURE__*/_react.default.createElement(_Typography.P, null, text), svg);
  };

  _exports.EmptyMessage = EmptyMessage;
});